// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"148":"1d1c61d2","326":"44333d8e","367":"56bf5f86","368":"9cafe971","558":"82857114","860":"ad150b1f"}[chunkId] + ".css";
};